export const badgeTokens = {
  'badge-font-size': 'var(--dp-font-size-xs)',
  'badge-font-weight': 'var(--dp-font-weight-semibold)',
  'badge-padding-x': 'var(--dp-spacing-sm)',
  'badge-padding-y': 'var(--dp-spacing-xs)',
  'badge-border-radius': 'var(--dp-border-radius-full)',
  'badge-text-color': 'var(--dp-color-text-inverse)',
  'badge-primary-bg': 'var(--dp-color-primary)',
  'badge-success-bg': 'var(--dp-color-success)',
  'badge-warning-bg': 'var(--dp-color-warning)',
  'badge-error-bg': 'var(--dp-color-error)',
  'badge-info-bg': 'var(--dp-color-info)',
  'badge-neutral-bg': 'var(--dp-color-text-secondary)',
} as const;
